import { Texture } from '@luma.gl/core';
import { ShaderModule, UniformTypes } from '@luma.gl/shadertools';

// Caution: order matters !!!
const uniformBlock = `\
uniform feFlightIconUniforms { 
    bool isGlobeView;
    float currentZoom;
    float cutoff;
    bool softEdge;
    float softEdgeMin;
    float softEdgeMax;
    bool outline;
    vec4 outlineColor;
    float outlineMin0;
    float outlineMin1;
    float outlineMax0;
    float outlineMax1;
    bool shadow;
    vec4 shadowColor;
} feFlightIcon;
`;

type FlightIconLayerBindings = {
    iconsTexture: Texture;
};

export type FlightIconLayerUniforms = {
    isGlobeView: boolean;
    currentZoom: number;
    cutoff: number;
    softEdge: boolean;
    softEdgeMin: number;
    softEdgeMax: number;
    outline: boolean;
    outlineColor: [number, number, number, number];
    outlineMin0: number;
    outlineMin1: number;
    outlineMax0: number;
    outlineMax1: number;
    shadow: boolean;
    shadowColor: [number, number, number, number];
};

export type FlightIconLayerShaderInputs = FlightIconLayerBindings & FlightIconLayerUniforms;

export const flightIconUniforms = {
    name: 'feFlightIcon',
    vs: uniformBlock,
    fs: uniformBlock,
    uniformTypes: {
        isGlobeView: 'f32',
        currentZoom: 'f32',
        cutoff: 'f32',
        softEdge: 'f32',
        softEdgeMin: 'f32',
        softEdgeMax: 'f32',
        outline: 'f32',
        outlineColor: 'vec4<f32>',
        outlineMin0: 'f32',
        outlineMin1: 'f32',
        outlineMax0: 'f32',
        outlineMax1: 'f32',
        shadow: 'f32',
        shadowColor: 'vec4<f32>'
    } as const satisfies UniformTypes<Required<FlightIconLayerUniforms>>
} as const satisfies ShaderModule<FlightIconLayerShaderInputs>;
